import React from 'react';
import { Mail } from 'lucide-react';
export function NewsletterSignup() {
  return <section className="py-24 bg-charcoal text-cream relative overflow-hidden" data-id="element-760">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#B5943A 1.5px, transparent 1.5px)',
      backgroundSize: '32px 32px'
    }} data-id="element-761"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-762">
        <div className="w-20 h-20 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-8" data-id="element-763">
          <Mail className="w-10 h-10 text-gold" data-id="element-764" />
        </div>

        <h2 className="text-4xl md:text-5xl font-serif mb-6 text-white" data-id="element-765">
          Join the Switchplate Gallery Family
        </h2>

        <p className="text-warmGray-light text-xl mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-766">
          Subscribe to our mailing list to receive exclusive offers, new product
          announcements, and home decor inspiration directly to your inbox.
        </p>

        <form className="flex flex-col sm:flex-row max-w-xl mx-auto gap-4" onSubmit={e => e.preventDefault()} data-id="element-767">
          <input type="email" placeholder="Enter your email address" required className="flex-1 px-6 py-4 bg-white/5 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:border-gold focus:ring-2 focus:ring-gold/50 rounded-sm transition-all text-lg" data-id="element-768" />
          <button type="submit" className="px-10 py-4 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors whitespace-nowrap text-sm uppercase tracking-wider shadow-lg" data-id="element-769">
            Subscribe
          </button>
        </form>

        <p className="text-sm text-warmGray-light mt-6 font-medium" data-id="element-770">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </section>;
}